// eslint-disable-next-line import/prefer-default-export
export const MOUSE_EVENT_KEY = {
    LEFT: 0,
    CENTER: 1,
    RIGHT: 2,
};
